import { render, staticRenderFns } from "./formSysColumnMenu.vue?vue&type=template&id=dbbebebe&"
import script from "./formSysColumnMenu.vue?vue&type=script&lang=js&"
export * from "./formSysColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports